const SITE = (process.env.SITE || process.env.NEXT_PUBLIC_SITE || "usbc").toLowerCase();
function getBusinessType() {
  return SITE;
}
const isUSBD = SITE === "usbd";
const isCABD = SITE === "cabd";
const isUSBC = SITE === "usbc";
const isCABC = SITE === "cabc";
const isBD = () => {
  var _a;
  return (_a = process.env.NEXT_PUBLIC_SITE) == null ? void 0 : _a.endsWith("BD");
};
const isBC = () => !isBD();
export {
  getBusinessType,
  isBC,
  isBD,
  isCABC,
  isCABD,
  isUSBC,
  isUSBD
};
